import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';

import './SectionAbout.css';

const SectionAbout = ({ theme }) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <section
        id="section-about"
        className={theme ? 'dark-mode' : 'light-mode'}
      >
        {/* <div class="wm wm-border light  fadeInDown text-align">BemVindo</div> */}
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <h1 className="text-left">Meeting the Minds</h1>

              <div className="text_about_minor mt-4">
                <p>
                  A ciência é fundamental para construirmos um amanhã melhor,
                  pois é através dela que conseguimos entender o universo ao
                  nosso redor e desenvolver tecnologias para melhorar a
                  qualidade de vida dos pacientes.
                </p>

                <p>
                  E nesta 5ª edição, a Libbs Farmacêutica está promovendo o
                  Meeting the Minds – Construindo juntos o amanhã no formato
                  híbrido, que tem como objetivo reunir os principais
                  profissionais do Brasil, com o intuito de fomentar discussões,
                  trocas de experiências e atualizações sobre mercado oncológico
                  e hematológico.
                </p>
              </div>

              <div className="spacer10" />

              {/* <a href="#" class="btn-custom font-weight-bold text-white sm-mb-30">About Us</a> */}
            </div>

            <div className="col-lg-6 mb-sm-30 text-center">
              <div className="de-images">
                {/* <img
                  className="di-small d-none d-md-block"
                  data-aos="fade-up"
                  src="https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fmisc%2F2.jpg?alt=media&token=f5211450-9748-4e81-85e3-b14c75993cbe"
                  alt=""
                /> */}
                {/* <img className="di-small-2" data-aos="fade-right" src="https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fmisc%2F3.jpg?alt=media&token=6f121ae6-9712-40df-8231-bc711b185b93" alt="" /> */}
                <img
                  className="img-fluid"
                  data-aos="fade-left"
                  src="https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fmtm%2F800x533%20exuro%20tipo02-8.png?alt=media&token=1df284f9-e06e-400e-aef0-669b0d6fd5fa"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionAbout;
